export { PagerComponent } from './pager.component';
export { PaginationComponent, PageChangedEvent } from './pagination.component';
export { PaginationModule } from './pagination.module';
export { PaginationConfig } from './pagination.config';



// WEBPACK FOOTER //
// ./.tmp/pagination/index.ts